import React from "react";
import { Play, ShieldCheck, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SecureTheirFuture() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll();
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll();
  return <section data-section-id="2045" id="your-familys-health-partner" className="relative w-full overflow-hidden bg-background text-foreground py-16 lg:py-24 xl:py-32">
      {}
      <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-primary/5 via-accent/10 to-transparent pointer-events-none" />
      
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-8 items-center">
          {}
          <div ref={leftRef} className={`flex flex-col justify-center space-y-8 lg:col-span-7 transition-all duration-1000 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <div className="space-y-6">
              <h1 className="font-serif text-5xl font-bold tracking-tight text-foreground sm:text-6xl xl:text-7xl/tight">
                Compassionate care for every{" "}
                <span className="relative inline-block px-2">
                  <span className="absolute inset-0 -rotate-1 bg-secondary rounded-lg opacity-90" />
                  <span className="relative z-10 text-secondary-foreground">family</span>
                </span>
                , every single day.
              </h1>
              <p className="max-w-[600px] text-lg text-muted-foreground md:text-xl/relaxed leading-relaxed">
                Freetown Family Clinic is your community-focused health center. We provide 
                personalized medical care for all generations, from newborn wellness to 
                comprehensive chronic disease management.
              </p>
            </div>

            <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
              <Link to="/ContactPage">
                <Button size="lg" className="w-full sm:w-auto text-base h-12 px-8 rounded-full shadow-xl shadow-primary/20 bg-primary hover:bg-primary/90 text-primary-foreground transition-all hover:scale-105">
                  Book Appointment
                  <ArrowRight className="ml-2 size-4" />
                </Button>
              </Link>
              <Link to="#">
                <Button variant="ghost" size="lg" className="w-full sm:w-auto text-base h-12 px-6 rounded-full border border-primary/20 text-foreground hover:bg-muted transition-colors">
                  <Play className="mr-2 size-4 fill-primary text-primary" />
                  Explore Services
                </Button>
              </Link>
            </div>

            <div className="flex items-center gap-4 text-sm text-muted-foreground pt-4">
              <div className="flex -space-x-2">
                {[1, 2, 3, 4].map(i => <div key={i} data-index={i} className="size-8 rounded-full border-2 border-background bg-muted overflow-hidden">
                    <img src={`/img/avatar_user_${i}.png`} alt="Local Resident" className="h-full w-full object-cover" />
                  </div>)}
              </div>
              <p className="font-medium">Trusted by Thousands of patients</p>
            </div>
          </div>

          {}
          <div ref={rightRef} className={`relative lg:col-span-5 transition-all duration-1000 ease-out delay-200 ${rightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"}`}>
            <div className="relative rounded-[80px] shadow-2xl shadow-primary/10 overflow-hidden group border-8 border-background">
              <div className="absolute inset-0 bg-gradient-to-tr from-primary/20 to-transparent mix-blend-multiply z-10 pointer-events-none" />
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1612706/img/canadian_family_living_room_sunlight.png" alt="Smiling Freetown family with their clinic physician" className="h-auto w-full object-cover transition-transform duration-1000 group-hover:scale-110" />
            </div>

            {}
            <div className="absolute -bottom-6 -left-6 md:bottom-8 md:-left-12 z-20 animate-bounce [animation-duration:4s]">
              <div className="flex items-center gap-3 rounded-2xl bg-card/90 p-4 shadow-2xl border border-border/50 backdrop-blur-md">
                <div className="flex size-10 items-center justify-center rounded-full bg-secondary text-secondary-foreground shadow-sm">
                  <ShieldCheck className="size-6" />
                </div>
                <div className="flex flex-col">
                  <span className="text-sm font-bold text-foreground tracking-tight">
                    Patient-Centered
                  </span>
                  <span className="text-xs text-muted-foreground font-mono">
                    Community Trusted
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}